module.exports = __webpack_public_path__ + "img/jigouyanglao_image_ylms.85681712.png";